import { parse, parseISO, format } from "date-fns";
import { ja } from 'date-fns/locale';
import Vue from "vue"
import { Logger } from "./api.service";

export default Vue.extend({

    methods: {

        parse(dt: string, formatString: string) {
            if (dt === null) {
                return null;
            }
            if (typeof formatString === 'undefined') {
                formatString = 'yyyyMMdd';
            }
            return parse(dt, formatString, Date.now());
        },

        parseISO(dt: string): Date {
            if (dt === null) {
                return null;
            }

            return parseISO(dt);
        },

        /**
         * .Net側から取得したDateTimeの文字列またはJSのDate型を表示用の日付文字列に変換
         */
        formatDate(dt: string | Date, formatString: string) {
            if (dt === null) {
                return '';
            }
            if (typeof formatString === 'undefined') {
                formatString = 'yyyy年 M月 d日';
            }

            if (typeof dt == 'string') {
                let _dt = parseISO(dt as string)
                if (_dt.toString() === 'Invalid Date') {
                    const baseDate = new Date(2000, 1, 1)
                    _dt = parse(dt as string, 'yyyyMMdd', baseDate);
                    if (_dt.toString() === 'Invalid Date' || _dt == baseDate) {
                        return '';
                    }
                }
                dt = _dt;
            }

            return format(dt, formatString);
        },

        formatDateDay(dt: string | Date, formatString: string) {
            if (dt === null) {
                return '';
            }
            if (typeof formatString === 'undefined') {
                formatString = 'yyyy年 M月 d日(E)';
            }

            if (typeof dt == 'string') {
                let _dt = parseISO(dt as string)
                dt = String(format(_dt, formatString, { locale: ja }));
            }

            return dt;
        },

        /**
         * yyyyMMddHHmmssの日付文字列を表示用の文字列に変換する
         */
        formatDateTime(dt: string | Date, formatString: string): string {

            try {
                if (typeof formatString === 'undefined') {
                    formatString = 'yyyy年 M月 d日 HH:mm';
                }

                if (dt == null) {
                    return ""
                }

                if (typeof dt == 'string') {
                    let _dt = parseISO(dt as string)
                    if (_dt.toString() === 'Invalid Date') {
                        const baseDate = new Date(2000, 1, 1)
                        _dt = parse(dt as string, 'yyyyMMddHHmmss', baseDate);
                        if (_dt.toString() === 'Invalid Date' || _dt == baseDate) {
                            return '';
                        }
                    }
                    dt = _dt;
                }
                return format(dt, formatString);
            } catch (e) {
                // Vueのテンプレート内で使う場合、エラーが出ると描画が止まってしまうので、エラーは出さないようにする
                Logger.logDebug(e)
                return ""
            }

        },

        /**
         * HHmmを表示用の時刻文字列に変換
         */
        formatTimeString(timeString) {
            if (timeString == null || timeString.length != 4) {
                return '';
            }

            return parseInt(timeString.substring(0, 2)) + ':'
                + timeString.substring(2, 4) + '～';
        },

    }

})
